import * as React from "react";
import Modal from "@mui/material/Modal";
import { Typography } from "@mui/material";
// import { Dialog } from '@blueprintjs/core';
import closeIcon from "./closeIcone/close.png";
import { PriceSentimentLineChart } from "./PriceSentimentLineChart"

function isMobile() {
    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const tabletWidth = 430;

    return viewportWidth <= tabletWidth;
}

export default function PriceSentimentDialog({ open, handleClose, coin }) {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            isCloseButtonShown={true}
            canOutsideClickClose={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                border: "none",
            }}
        ><div style={{
            height: "60%",
            width: "90%",
            maxWidth: "600px",
            maxHeight: "400px",
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white", 
            border: "none",
            padding:"10px",
            // border: "2px solid #000",
            boxShadow: 24,
            // "@media (max-width: 768px)": {
            //     width: "95%",
            //     height:"600px", 
            //   },
            // padding: "10px 20px 0px 20px",
        }}>
                <Typography sx={{ margin: "auto", fontWeight: "bold",fontSize:"20px",paddingBottom:"5px" }}>
                    Price & Sentiment Correlation
                    </Typography>
                <PriceSentimentLineChart coin={coin} />
            </div>

        </Modal>
    );
}
